<template>
  <div style="padding:15px">
    <a-form :form="form" @submit="onSubmit">
      <a-card>
        <a-form-item v-bind="formItemLayout">
          <span style="float:left">社員ID</span>
          <a-input
            v-decorator="['eid',{
            rules: [{
              pattern: RegExp('^[0-9]{5}$'), message: 'The input is not valid.!(00000~99999)',
            }, {
              required: true, message: 'Please input a EID!',
            }]
          }]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span style="float:left">アカウント</span>
          <a-input
            v-decorator="['account',{
            rules: [{
              pattern: RegExp('^[a-z][0-9a-z-_.]{1,9}$'), message: 'The input is not valid.!(^[a-z][0-9a-z-_.]{1,9}$)',
            }, {
              required: true, message: 'Please input a Account!',
            }]
          }]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <span style="float:left">メール</span>
          <a-input
            v-decorator="['email',{
            rules: [{
              type: 'email', message: 'The input is not valid E-mail!',
            }, {
              required: true, message: 'Please input a E-mail!',
            }]
          }]"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayout">
          <a-row>
            <span style="float:left">入社日</span>
          </a-row>
          <a-row>
            <a-date-picker
              :allowClear="false"
              v-decorator="['joined_at']"
              style="float:left"
              format="YYYY-MM-DD"
            />
          </a-row>
        </a-form-item>

        <div>
          <a-row>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout">
                <span style="float:left">名前</span>
                <a-input
                  v-decorator="['lastname',{
                  rules: [{
                    max: 5, message: 'The input is not valid.!(max:5)',
                  }, {
                    required: true, message: 'Please input a last name!',
                  }]
                }]"
                  addonBefore="姓"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item v-bind="formItemLayout">
                <span style="float:left">*****</span>
                <a-input
                  v-decorator="['firstname',{
                  rules: [{
                      max: 5, message: 'The input is not valid.!(max:5)',
                    }, {
                      required: true, message: 'Please input a first name!',
                    }]
                  }]"
                  addonBefore="名"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>

        <a-form-item v-bind="formItemLayout">
          <a-row>
            <span style="float:left">性別</span>
          </a-row>
          <a-row>
            <a-radio-group
              v-decorator="['sex',{
                rules: [{
                  required: true, message: 'Please select a sex!',
                }]
              }]"
              :options="sex_options"
              style="float:left"
            />
          </a-row>
        </a-form-item>
      </a-card>
      <a-form-item>
        <a-button :loading="isLoading" style="float:left;margin:10px 10px;" type="primary" html-type="submit">作成</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
const sex_options = [
  {
    label: "女",
    value: "female"
  },
  {
    label: "男",
    value: "male"
  },
  {
    label: "未設定",
    value: "unknown"
  }
];
export default {
  name: "EditInfo",
  created() {
    this.form = this.$form.createForm(this, {
      onFieldsChange: (_, changedFields) => {
        this.$logger.d("EditInfo", "onFieldsChange", {
          changedFields: changedFields
        });
        this.$emit("change", changedFields);
      },
      mapPropsToFields: () => {
        return {
          eid: this.$form.createFormField({
            value: ""
          }),
          account: this.$form.createFormField({
            value: ""
          }),
          email: this.$form.createFormField({
            value: ""
          }),
          joined_at: this.$form.createFormField({
            value: this.$moment()
          }),
          lastname: this.$form.createFormField({
            value: ""
          }),
          firstname: this.$form.createFormField({
            value: ""
          }),
          sex: this.$form.createFormField({
            value: ""
          })
        };
      },
      onValuesChange: (_, values) => {
        this.$logger.d("EditInfo", "onValuesChange", {
          values: values
        });
      }
    });
  },
  data() {
    return {
      sex_options,
      formItemLayout: {
        wrapperCol: {
          span: 24
        }
      },
      isLoading:false
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        this.$logger.d("", "onSubmit", {
          values: values
        });
        if (!err) {
          let token = this.$store.getters.token
          this.isLoading = true
          this.$api.employee.create({
            token:token,
            eid:values.eid,
            joined_at:values.joined_at.format('YYYY/MM/DD'),
            account:values.account,
            email:values.email,
            password:'ma2019',
            userinfo:{
              sex:values.sex,
              lastname:values.lastname,
              firstname:values.firstname
            }
          }).then(data => {
              let resp = data.data;
              this.$logger.d("", "onSubmit.update", {
                response: resp
              });
              if (resp.error) {
                // this.$notification.error({
                //   message: "エラー:" + resp.error.code,
                //   description: resp.error.description
                // });
                this.$error_handler(this,resp.error)
              } else {
                this.$notification.success({
                  message: "作成完了しました"
                });
                this.$router.push({name:'employeelist'})
              }
              this.isLoading = false
            }).catch(err => {
              this.$logger.e("", "api", {
                error: err
              });
              this.$notification.error({
                message: "エラー",
                description: "サーバ通信エラー"
              });
              this.isLoading = false
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.ant-form-item {
  margin: 0 0;
}
</style>
